export class LivekitVideoToken {
  // Assigned by `fromJson`, which is the only way this class is built.
  token!: string;
  roomName!: string;
  participantName!: string;

  notBefore!: Date;
  expiresAt!: Date;

  livekitServerUrl?: string;

  /**
   * The session this token opens.
   *
   * An authenticated caller already holds these from the ScheduledEvent it fetched to ask for the
   * token. A direct-link client never fetches one -- it presents an opaque link and the server
   * resolves the session behind it -- so the granted token is the only place they arrive.
   */
  calendarEventId?: number;
  personaClientId?: number | null;
  personaProviderId?: number | null;

  static fromJson(json: any): LivekitVideoToken {
    const token = new LivekitVideoToken();

    token.token = json.token;
    token.roomName = json.room_name;
    token.participantName = json.persona_identity;

    token.notBefore = new Date(json.nbf);
    token.expiresAt = new Date(json.exp);

    token.livekitServerUrl = json.livekit_server_url ?? '';

    token.calendarEventId = json.calendar_event_id ?? undefined;
    token.personaClientId = json.persona_client_id ?? null;
    token.personaProviderId = json.persona_provider_id ?? null;

    return token;
  }
}
